// extracted by mini-css-extract-plugin
export default {"dropdownManage":"Buttons_dropdownManage__ChK24"};